<template>
  <div id="status-card-displayer">
    <h5>{{title}}</h5>
    <StatusCard
      :title="card.title"
      :description="card.status"
      :link="card.value"
      v-for="(card, i) in displayCards"
      :key="i"
    />

    <div class="col-12" v-if="!showAll">
      <LinkButton @click="showAllCards" v-if="cards.length > 1">
        Ver anteriores
        <img src="../assets/images/chevron-bottom.png" />
      </LinkButton>
    </div>
  </div>
</template>

<script>
import Moment from 'moment';
import StatusCard from './StatusCard.vue';
import LinkButton from './Button/LinkButton.vue';

export default {
  name: 'StartupCardDisplayer',
  props: {
    cards: Array,
    title: {
      type: String,
      default: 'Status',
    }
  },
  components: {
    StatusCard,
    LinkButton,
  },
  computed: {
    displayCards() {
      const cards = [...this.cards].sort((a, b) => {
        return Moment(a.fecha ? a.fecha.date : 0).format('x') - Moment(b.fecha ? b.fecha.date : 0).format('x');
      })
      if (!this.showAll) return [cards[cards.length-1]];
      return cards.reverse();
    },
  },
  watch: {
    cards(){
      this.showAll = false;
    },
  },
  data() {
    return {
      showAll: false,
    };
  },
  methods: {
    showAllCards() {
      this.showAll = true;
    },
  },
};
</script>

<style scoped lang="scss">
h5 {
  font-weight: 400;
  font-size: 12px;
  color: #979797;
  margin: 0;
  margin-bottom: 3px;
}
</style>
